import { Popover } from "@mui/material";
import { ReactNode } from "react";

interface CustomProps {
  anchorRef: any;
  open: boolean;
  handleClose: Function;
  children?: ReactNode;
  width?: string;
  classes?: any;
  padding?: any;
  /** Overrides the default elevation-8 shadow on the panel. */
  shadow?: string;
  /** Overrides the theme's corner radius on the panel. */
  borderRadius?: string;
  /** Overrides the default hairline around the panel. */
  border?: string;
  ariaLabel?: string;
}

const CustomPopper = (props: CustomProps) => {
  const getPopper = () => {
    return (
      <Popover
        anchorEl={props.anchorRef}
        // disableScrollLock
        onClose={() => props.handleClose()}
        open={props.open}
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
        PaperProps={{
          elevation: 8,
          ...(props.ariaLabel && {
            role: "dialog",
            "aria-modal": true,
            "aria-label": props.ariaLabel,
          }),
          sx: {
            ml: 1,
            mt: 1.5,
            // `??` not `||` — a caller passing 0 means no padding, not default.
            p: props.padding ?? 1,
            width: props.width,
            maxWidth: props.width ? "90vw" : undefined,
            overflowX: "hidden",
            overflowY: "auto",
            border: props.border ?? "1px solid rgba(71, 85, 105, 0.25)",
            backgroundColor: "white",
            ...(props.shadow && { boxShadow: props.shadow }),
            ...(props.borderRadius && { borderRadius: props.borderRadius }),
          },
        }}
        sx={{
          zIndex: 1300, // Ensure it's above other elements
          ...(props.classes || {}),
        }}
      >
        {props.children}
      </Popover>
    );
  };

  return getPopper();
};

export default CustomPopper;
